import React from "react";
import { useTranslation } from "react-i18next";
import SkillsTab from "../sessions/NotesAndSkills/SkillsTab";
import { useSkills } from "../../hooks/useSkills";
type StudentSkillsProps = {
  finishedSkills: string[];
  isEditable?: boolean;
  handleUpdateSkills?: (finishedSkills: string[]) => Promise<boolean>;
};
export default function StudentSkills(props: StudentSkillsProps) {
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { finishedSkills, isEditable, handleUpdateSkills } = props;
  const { skills, onSkillClick, setFinishedSkills } = useSkills(
    finishedSkills,
    handleUpdateSkills
  );
  return (
    <div className="w-full flex flex-col  bg-white min-h-screen">
      <div className="w-full py-4 flex justify-between items-center px-6">
        <h2 className="text-gray-900 text-lg leading-8 font-semibold">
          {t("skillsList")}
        </h2>
        <div className="flex hidden items-center gap-4">
          <button className="text-[#306CE4] text-xs ">{t("closeAll")}</button>
          <button className="text-[#306CE4] text-xs ">{t("openAll")}</button>
        </div>
      </div>
      <SkillsTab
        colorPrimary={true}
        finishedSkills={finishedSkills || []}
        isEditable={!!isEditable}
        handleUpdateSkills={handleUpdateSkills}
      />
    </div>
  );
}
